const CHECKOUT_STEP                       = 'CHECKOUT_STEP';
const RESET_STORE                         = 'RESET_STORE';
const INITIALISE_STORE                    = 'INITIALISE_STORE';
const SET_CUSTOMER_CONSENTS                = "SET_CUSTOMER_CONSENTS";
const SET_BILLING_ADDRESS                  = 'SET_BILLING_ADDRESS';
const SET_USE_DELIVERY_ADDRESS_AS_BILLING_ADDRESS = 'SET_USE_DELIVERY_ADDRESS_AS_BILLING_ADDRESS';
const SET_SELECTED_DELIVERY_ADDRESS        = 'SET_SELECTED_DELIVERY_ADDRESS';
const SET_AGE_VERIFIED                     = 'SET_AGE_VERIFIED';
const SET_PENDING_PURCHASE_GA_INFO         = 'SET_PENDING_PURCHASE_GA_INFO';
const CLEAR_PENDING_PURCHASE_GA_INFO       = 'CLEAR_PENDING_PURCHASE_GA_INFO';

export const state = () => initialState();

function initialState () {
  return {
    checkout_step : 0, //the checkout journey step the user has progressed to. (route.meta.navigation)
    customer_consents: [],
    use_delivery_address_as_billing_address: true,
    selected_delivery_address: "",
    billingAddress:{
      name          : '',
      address_line_1: '',
      address_line_2: '',
      town_city     : '',
      postcode      : '',
      country_code  : ''
    },
    age_verified: false,
    pending_purchase_ga_info: null,
  }
}

export const mutations = {

    [SET_CUSTOMER_CONSENTS](state, consents) {
      state.customer_consents = consents;
    },

    [SET_USE_DELIVERY_ADDRESS_AS_BILLING_ADDRESS](state, value){
      state.use_delivery_address_as_billing_address = value;
    },
    [SET_SELECTED_DELIVERY_ADDRESS](state, value){
      state.selected_delivery_address = value;
    },





    /**
    * Set an index of the billing address
    * @type {object}
    */
    [SET_BILLING_ADDRESS](state,value){
      Object.assign(state.billingAddress, value);
    },


    [RESET_STORE] (state) {

      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },

    /**
    * Set checkout step
    * @type {int} step
    */
    [CHECKOUT_STEP](state, value){
      state.checkout_step = value;
    },

    [SET_AGE_VERIFIED](state, value) {
      state.age_verified = !!value;
    },

    [SET_PENDING_PURCHASE_GA_INFO](state, payload) {
      state.pending_purchase_ga_info = payload;
    },

    [CLEAR_PENDING_PURCHASE_GA_INFO](state) {
      state.pending_purchase_ga_info = null;
    },

    /**
     * Initialises the store to the last state saved in local storage
     */
    [INITIALISE_STORE](state) {

      try{

        // Check if the ID exists
        if(localStorage.getItem('toggle_persisted')) {
          // Replace the state object with the stored item
          let savedState = JSON.parse(localStorage.getItem('toggle_persisted'));
          Object.keys(savedState).forEach(key => {
            state[key] = savedState[key]
          });
          state.age_verified = !!state.age_verified;
        }
      }catch(e) { // local storage disabled, so we won't use it.
        return false;
      }

    }

}

export const getters = {

  getSelectedDeliveryAddress: (state) => {
    return state.selected_delivery_address;
  },

  getUseDeliveryAddressAsBillingAddress: (state) => {
    return state.use_delivery_address_as_billing_address;
  },

  getBillingAddress: state => {
    return state.billingAddress
  },

  getCustomerConsents: (state) => {
    return state.customer_consents;
  },

    getCheckoutStep: (state) => {
      return state.checkout_step;
    },

    getAgeVerified: (state) => {
      return state.age_verified;
    },

    getPendingPurchaseGaInfo: (state) => {
      return state.pending_purchase_ga_info;
    },

}
